var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNoPartner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 140,
    viewBox: "0 0 128 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9277_78607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.1183 138.886C62.1892 140.002 64.7943 140.006 66.8747 138.908C123.569 108.795 127.839 49.5144 127.862 32.6535C127.862 31.2983 127.467 29.9725 126.725 28.8383C125.982 27.7042 124.925 26.811 123.682 26.268L66.957 0.881964C66.0542 0.479936 65.0773 0.27074 64.0889 0.267787C63.1005 0.264834 62.1224 0.468189 61.2172 0.864816L4.67272 25.7733C3.44338 26.3061 2.39327 27.1807 1.6475 28.2927C0.901723 29.4048 0.491722 30.7076 0.46634 32.0459C0.154523 48.8209 3.28196 108.26 60.1183 138.886Z",
    fill: "url(#paint0_linear_9277_78607)",
    fillOpacity: 0.12
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_9277_78607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.0138 43.9939C50.3525 43.9939 49.0057 42.6471 49.0057 40.9858V32.9953C49.0057 31.3339 50.3525 29.9872 52.0138 29.9872C53.6751 29.9872 55.0219 31.3339 55.0219 32.9953L55.0219 40.9858C55.0219 42.6471 53.6751 43.9939 52.0138 43.9939ZM34.8777 48.676C33.2183 48.676 31.8731 50.0212 31.8731 51.6806C31.8731 53.3401 33.2183 54.6853 34.8777 54.6853H42.8914C44.5508 54.6853 45.8961 53.3401 45.8961 51.6806C45.8961 50.0212 44.5508 48.676 42.8914 48.676H34.8777ZM95.2362 81.3126C96.8956 81.3126 98.2408 79.9673 98.2408 78.3079C98.2408 76.6485 96.8956 75.3033 95.2362 75.3033H87.2224C85.563 75.3033 84.2178 76.6485 84.2178 78.3079C84.2178 79.9673 85.563 81.3126 87.2224 81.3126H95.2362ZM81.2156 87.111C81.2156 85.4496 79.8688 84.1029 78.2074 84.1029C76.5461 84.1029 75.1993 85.4496 75.1993 87.111V95.1015C75.1993 96.7628 76.5461 98.1096 78.2074 98.1096C79.8688 98.1096 81.2156 96.7628 81.2156 95.1015V87.111Z",
    fill: "#5498FF",
    fillOpacity: 0.07
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_9277_78607)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4258 55.9473C61.8099 57.3314 64.054 57.3314 65.4381 55.9473L74.8272 46.5582C77.1237 44.2617 80.8469 44.2617 83.1434 46.5582C85.4398 48.8546 85.4398 52.5779 83.1434 54.8743L73.7542 64.2635C72.3701 65.6476 72.3701 67.8917 73.7542 69.2758L75.6338 71.1554C77.018 72.5395 79.262 72.5395 80.6461 71.1554L90.0353 61.7662C96.138 55.6635 96.138 45.769 90.0353 39.6663C83.9325 33.5635 74.038 33.5635 67.9353 39.6663L58.5462 49.0554C57.1621 50.4395 57.1621 52.6836 58.5462 54.0677L60.4258 55.9473ZM53.9961 67.3893C55.3802 66.0052 55.3802 63.7611 53.9961 62.377L52.1165 60.4974C50.7324 59.1133 48.4883 59.1133 47.1042 60.4974L37.2784 70.3232C31.1756 76.4259 31.1756 86.3204 37.2784 92.4232C43.3811 98.5259 53.2756 98.5259 59.3784 92.4232L69.2042 82.5973C70.5883 81.2132 70.5883 78.9692 69.2042 77.585L67.3246 75.7054C65.9405 74.3213 63.6964 74.3213 62.3123 75.7054L52.4864 85.5313C50.19 87.8277 46.4667 87.8277 44.1703 85.5313C41.8738 83.2348 41.8738 79.5116 44.1703 77.2151L53.9961 67.3893Z",
    fill: "url(#paint1_linear_9277_78607)",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9277_78607",
    x: 0.44838,
    y: -4.238,
    width: 127.414,
    height: 143.965,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4.50576
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.40231
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9277_78607"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_9277_78607",
    x: 31.8731,
    y: 20.9789,
    width: 66.3677,
    height: 77.1307,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.00825
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.50413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.13 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9277_78607"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_9277_78607",
    x: 32.7013,
    y: 26.081,
    width: 61.911,
    height: 70.9193,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -9.00825
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.50413
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9277_78607"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9277_78607",
    x1: 35.8477,
    y1: 24.3328,
    x2: 93.7143,
    y2: 140.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B1C2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EADBE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9277_78607",
    x1: 34.2987,
    y1: 67.2752,
    x2: 93.8136,
    y2: 67.2752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#316ECA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5364FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoPartner);
export default __webpack_public_path__ + "static/media/icon_no_partner.a6e03162c7ca8b0bc0448a73ff23e788.svg";
export { ForwardRef as ReactComponent };